document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-menu-toggle]').forEach(button=>button.addEventListener('click',()=>{
    const menu=document.querySelector('[data-mobile-menu]');
    const isOpen=menu.hasAttribute('data-open');
    if(isOpen) menu.removeAttribute('data-open'); else menu.setAttribute('data-open','');
    button.setAttribute('aria-expanded',String(!isOpen));
  }));
  document.querySelectorAll('[data-quantity]').forEach(group=>{
    const input=group.querySelector('input');
    group.querySelectorAll('button').forEach(btn=>btn.addEventListener('click',()=>{
      const delta=btn.dataset.action==='plus'?1:-1;
      input.value=Math.max(1,Number(input.value||1)+delta);
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
  });
  const announcement=document.querySelector('[data-announcement]');
  if(announcement){
    const items=[...announcement.querySelectorAll('.announcement__item')];
    if(items.length>1){let i=0;setInterval(()=>{items[i].classList.remove('is-active');i=(i+1)%items.length;items[i].classList.add('is-active')},3500)}
  }
  document.querySelectorAll('[data-sticky-atc]').forEach(btn=>btn.addEventListener('click',()=>{
    const form=document.querySelector('#MainProductForm');
    if(form){const submit=form.querySelector('[type="submit"]'); if(submit) submit.click();}
  }));
});

// Zupy Motion Hero
(() => {
  const initMotionHero = (root) => {
    if (!root || root.dataset.motionReady === 'true') return;
    const slides = [...root.querySelectorAll('[data-motion-slide]')];
    const dots = [...root.querySelectorAll('[data-motion-dot]')];
    if (slides.length < 2) return;
    root.dataset.motionReady = 'true';
    let current = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    let timer = null;
    const delay = Math.max(2500, Number(root.dataset.autoplay || 3000));
    const show = (index) => {
      slides[current]?.classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current]?.classList.add('is-active');
      dots[current]?.classList.add('is-active');
    };
    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(() => { show(current + 1); schedule(); }, delay);
    };
    root.querySelector('[data-motion-next]')?.addEventListener('click', () => { show(current + 1); schedule(); });
    root.querySelector('[data-motion-prev]')?.addEventListener('click', () => { show(current - 1); schedule(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); schedule(); }));
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      root.addEventListener('mouseenter', () => clearTimeout(timer));
      root.addEventListener('mouseleave', schedule);
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) clearTimeout(timer); else schedule();
    });
    schedule();
  };
  const boot = () => document.querySelectorAll('[data-motion-hero]').forEach(initMotionHero);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll?.('[data-motion-hero]').forEach(initMotionHero));
})();
